<ng-container *ngIf="isSupplyChannelToggleAvailable">
  <ng-container *ngrxLet="status$ as status">
    <h2>{{ '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.TITLE' | translate }}</h2>
    <div class="flex flex-row direction-row flex-wrap">
      <div class="toggle-wrapper">
        <div class="flex items-center gap-1">
          <h3>
            {{ '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.PUMP_CONTROL.TITLE' | translate }}
          </h3>
        </div>

        <ng-container *ngFor="let pumpControlFeatures of listPumpControlFeatures">
          <app-src-settings-pump-control
            [status]="status"
            [pumpControlIds]="pumpControlIds"
            [pumpControlFeatures]="pumpControlFeatures"
          ></app-src-settings-pump-control>
        </ng-container>
        <ng-container *ngIf="status | value2: featurePropertyKey.active as statusValue">
          <p *ngIf="statusValue === bool.True">
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.PUMP_CONTROL.SRC_ENABLED.DESCRIPTION'
                | translate
            }}
          </p>
          <p *ngIf="statusValue !== bool.True">
            {{
              '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.PUMP_CONTROL.SRC_DISABLED.DESCRIPTION'
                | translate
            }}
          </p>
        </ng-container>
      </div>
      <ng-container *ngIf="condensateFeatures$ | async as condensateFeatures">
        <div *ngIf="condensateFeatures?.isEnabled" class="toggle-wrapper">
          <div class="flex items-center gap-1">
            <h3>
              {{
                '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.CONDENSATE_AVOIDANCE.TITLE'
                  | translate
              }}
            </h3>
          </div>
          <app-src-settings-condensate-avoidance
            [status]="status"
            [condensateFeatures]="condensateFeatures"
          >
          </app-src-settings-condensate-avoidance>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
